<hr class="line" [ngStyle]="{ background: newColor }" />

<app-topnav [pagename]="pageTitle" [clientLogo]="clientLogo"></app-topnav>

<div class="static-dashboard-frame-wrap">
  <iframe
    *ngIf="iframeSrc"
    class="static-dashboard-frame"
    [src]="iframeSrc"
    title="{{ pageTitle }}"
  ></iframe>
</div>
